import { NgModule } from '@angular/core';
import { FaqRoutingModule } from './faq.routing.module';
import { FaqComponent } from './faq.component';
import { SharedModule } from '../shared/shared.module';
import { QuestionsComponent } from './questions/questions.component';
import { MaterialModule } from '../shared/material/material.module';
import { ScrollToModule } from '@hkjeffchan/ngx-scroll-to';
import { CommonModule } from '@angular/common';

@NgModule({
	imports: [FaqRoutingModule, SharedModule, MaterialModule, ScrollToModule.forRoot(), CommonModule],
	declarations: [FaqComponent, QuestionsComponent],
	providers: [],
})
export class FaqModule {}
